import _ from 'lodash';
import dataSources from './datasources';

const getPanelModels = (panel) => {
  // Get datasources that has signals or plotlines
  return _.uniq(_.reduce(panel.properties, (result, property) => {
    if (dataSources[property.type]?.source?.getUsedSystemModels) {
      return [...result, ...dataSources[property.type]?.source.getUsedSystemModels(property)];
    }
    return result;
  }, []));
};

const getPanelAssets = (panel) => {
  // Get datasources that has signals or plotlines
  return _.reduce(panel.properties, (result, property) => {
    if (dataSources[property.type]?.source?.getUsedAssets) {
      return [...result, ...(dataSources[property.type]?.source.getUsedAssets(property).static ?? [])];
    }
    return result;
  }, []);
};

const hasDynamicAssetsPanel = (panel) => {
  // Get datasources that has signals or plotlines
  return _.some(panel.properties, (property) => {
    if (dataSources[property.type]?.source?.getUsedAssets) {
      return dataSources[property.type]?.source.getUsedAssets(property).isDynamic ?? false;
    }
    return false;
  });
};

const getModels = (dashboard) => {
  return _.uniq(_.reduce(dashboard?.data?.panels ?? [], (result, panel) => {
    return [...result, ...(getPanelModels(panel) ?? [])];
  }, []));
};

const getAsset = (dashboard) => {
  return _.uniqBy(_.reduce(dashboard?.data?.panels ?? [], (result, panel) => {
    return [...result, ...(getPanelAssets(panel) ?? [])];
  }, []), 'id');
};

const hasDynamicAssets = (dashboard) => {
  return _.some(dashboard?.data?.panels, hasDynamicAssetsPanel);
};

export const addModelsAndAssetsToDashboard = (dashboard) => {
  return {
    ...dashboard,
    data: {
      ...(dashboard.data ?? {}),
      models: getModels(dashboard),
      assets: getAsset(dashboard),
      hasDynamicAssets: hasDynamicAssets(dashboard)
    }
  };
};

